import {withRouter} from 'react-router-dom';
import React from 'react';
import {Nav} from 'react-bootstrap';
import {setMenuData} from '../../services/redux/actions/GeneralAction';
import HelperGeneral from '../../helpers/HelperGeneral';
import {reduxStore} from '../../services/redux/ReduxIndex';
import UserInfo from "../auth/UserInfo";

class DropdownMenu extends React.Component {
    getMenuItemTitle(menuItem) {
        return menuItem?.title
    }

    click(item) {
        if (item?.to) {
            HelperGeneral.pageChange(this, item?.to);
        }
        setMenuData({leftMenuVisible: false});
    }

    getMenuItem(menuItem, depthLevel, index) {
        const userInfo = UserInfo.info();
        let title = this.getMenuItemTitle(menuItem, index, depthLevel);

        if (userInfo && userInfo?.user_roles_id === 3 && menuItem?.id === "campaign") {
            return false;
        }

        return (
            <Nav.Link
                href={"#"}
                onClick={() => this.click(menuItem)}
                key={menuItem?.id}
                eventKey={menuItem?.id}
            >
                {title}
            </Nav.Link>
        )
    };

    render() {
        const {menuData} = reduxStore.getState().GeneralReducer;
        let {config} = this.props;
        let options = [];

        config?.map((item) => {
            options?.push(this.getMenuItem(item))
        })

        return (
            <Nav>
                {options}
            </Nav>
        )
    }
}

DropdownMenu.defaultProps = {
    depthLevel: 0,
    active: 0,
    menuItem: {},
}

export default withRouter(DropdownMenu);

